/**
 * Single source of truth for design system color palettes.
 * Imported by tailwind.config.js and the design system.
 *
 * 50 is lightest, 950 is darkest.
 */
export const colorPalette = {
  brand: {
    50: '#F0F9FF',
    100: '#D8E9FE',
    200: '#A9D0FD',
    300: '#64A5FD',
    400: '#2A7FFE',
    500: '#0041FF',
    600: '#263ECA',
    700: '#253CA2',
    800: '#233A7B',
    900: '#192958',
    950: '#121E40',
  },
  'brand-neutral': {
    50: '#FDFCFB',
    100: '#F6F3ED',
    200: '#F0EBE2',
    300: '#DFD7CB',
    400: '#C9C0B0',
    500: '#9D978A',
    600: '#76736A',
    700: '#5F5C55',
    800: '#484640',
    900: '#32312E',
    950: '#121212',
  },
  'true-gray': {
    50: '#FCFCFC',
    100: '#F8F8F8',
    200: '#E9E9E9',
    300: '#D0D0D0',
    400: '#B2B2B2',
    500: '#989898',
    600: '#737373',
    700: '#525252',
    800: '#3A3A3A',
    900: '#262626',
    950: '#171717',
  },
}

/** Tailwind v3 red, green, and yellow, kept for existing UI states. */
export const supportColorPalette = {
  red: {
    50: '#fef2f2',
    100: '#fee2e2',
    200: '#fecaca',
    300: '#fca5a5',
    400: '#f87171',
    500: '#ef4444',
    600: '#dc2626',
    700: '#b91c1c',
    800: '#991b1b',
    900: '#7f1d1d',
    950: '#450a0a',
  },
  green: {
    50: '#f0fdf4',
    100: '#dcfce7',
    200: '#bbf7d0',
    300: '#86efac',
    400: '#4ade80',
    500: '#22c55e',
    600: '#16a34a',
    700: '#15803d',
    800: '#166534',
    900: '#14532d',
    950: '#052e16',
  },
  yellow: {
    50: '#fefce8',
    100: '#fef9c3',
    200: '#fef08a',
    300: '#fde047',
    400: '#facc15',
    500: '#eab308',
    600: '#ca8a04',
    700: '#a16207',
    800: '#854d0e',
    900: '#713f12',
    950: '#422006',
  },
}
